(function () {
  if (customElements.get('ce-pagination-infinite-scroll') !== undefined) {
    return;
  }

  class PaginationInfiniteScroll extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        collection: 'ce-collection',
        iconSpinnerContainer: '[data-pagination-infinite-scroll-icon-spinner-container]',
        iconSpinner: '[data-pagination-infinite-scroll-icon-spinner-container] > svg',
      };

      this.elements = null;

      this.url = this.getAttribute('url');
      this.isLoading = false;

      this.intersectionObserver = null;
    }

    parsedCallback() {
      this.elements = {
        collection: document.querySelector(this.selectors.collection),
        iconSpinnerContainer: this.querySelector(this.selectors.iconSpinnerContainer),
        iconSpinner: this.querySelector(this.selectors.iconSpinner),
      };

      const callback = (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            if (this.isLoading) {
              return;
            }

            this.isLoading = true;
            this.playAnimationLoading();
            this.elements.collection.paginateInfiniteScroll(this.url);
          }
        }
      };

      const options = {
        rootMargin: '0% 0% 50% 0%',
      };

      this.intersectionObserver = new IntersectionObserver(callback, options);
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }

    playAnimationLoading() {
      requestAnimationFrame(() => {
        this.elements.iconSpinnerContainer.style.display = 'flex';
      });

      const keyframes = [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }];

      const options = {
        duration: Themu.prefersReducedMotion ? 3000 * 6 : 3000,
        iterations: Infinity,
        fill: 'both',
      };

      this.elements.iconSpinner.animate(keyframes, options);
    }
  }

  customElements.define('ce-pagination-infinite-scroll', PaginationInfiniteScroll);
})();
